import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import type { TemplateBundle } from '@lumen5/luminary';

import { GlobalTemplate } from 'js/src/client';
import { loadTemplateBundle } from 'js/src/data/templates/templates-operations';
import {
    getGlobalTemplateSceneDesignId,
    getTemplateBundle,
} from 'js/src/data/templates/templates-selectors';
import { ErrorReporter } from 'js/src/libs/error-reporter';
import type { RootState } from 'js/src/libs/RootState';
import { useAppDispatch } from 'js/src/libs/RootState';

const GLOBAL_TEMPLATE_ID = GlobalTemplate.GLOBAL_TEMPLATE_ID as string;

export function useGlobalTemplateBundle(): {
    templateBundle: TemplateBundle | null;
    sceneDesignId: string | null;
} {
    const dispatch = useAppDispatch();
    const templateBundle = useSelector((state: RootState) =>
        getTemplateBundle(state, GLOBAL_TEMPLATE_ID),
    );
    const sceneDesignId = useSelector(getGlobalTemplateSceneDesignId);

    useEffect(() => {
        dispatch(loadTemplateBundle(GLOBAL_TEMPLATE_ID)).catch((error: unknown) => {
            ErrorReporter.capture(error);
        });
    }, [dispatch]);

    return { templateBundle, sceneDesignId };
}
